import { Component, Input } from '@angular/core';
import { FiltersComponent } from '../../common/filters.component';
import { OrganizationNameType } from '@/common/enums/OrganizationNameType';

enum CustomerType {
	PRIVATE = 0,
	COMPANY = 1,
}

@Component({
	selector: 'app-event-business-filters',
	templateUrl: './event-business-filters.component.html',
	styleUrls: ['./event-business-filters.component.css'],
})
export class EventBusinessFiltersComponent extends FiltersComponent {
	@Input() organization: Array<any>;
	@Input() profile: Array<any>;
	@Input() statusNames: Array<any>;
	@Input() documentTypes: Array<any>;
	@Input() owners: Array<any>;
	@Input() yesno: Array<any>;
	customerType = CustomerType;
	filters = {
		date_from: null,
		date_to: null,
		due_from: null,
		due_to: null,
		date: null,
		statusNames: [],
		documentTypes: [],
		owners: [],
		settled: [],
		search: null,
		client: [],
		company: [],
		selectedFilterCustomerKind: CustomerType.COMPANY,
		get_organization_name: OrganizationNameType.RETURN_NAME,
	};

	protected filtersDefinition = {
		client: {
			type: 'string',
			isArray: true,
		},
		company: {
			type: 'string',
			isArray: true,
		},
		selectedFilterCustomerKind: {
			type: 'number',
			isArray: false,
		},
		get_organization_name: {
			type: 'number',
			isArray: false,
		},
	};

	filtersDefault() {
		this.filtersClear();
	}

	changeSelectedData(value: boolean): void {
		if (value) {
			this.filters.company = [];
		}
		if (!value) {
			this.filters.client = [];
		}
	}
}
